import { SettingsSidebar } from "./SettingsSidebar";

interface SettingsLayoutProps {
  children: React.ReactNode;
}

export const SettingsLayout = ({ children }: SettingsLayoutProps) => {
  return (
    <div className="grid md:grid-cols-4 gap-6">
      <div className="md:col-span-1">
        <SettingsSidebar />
      </div>
      <div className="md:col-span-3 space-y-6">
        {children}
      </div>
    </div>
  );
};
